module.exports = __webpack_public_path__ + "img/color-1@2x.0a2f7bc.png";